export enum UserRole {
    User = 'User',
    Manager = 'Manager',
    Administrator = 'Administrator',
    SuperAdministrator = "SuperAdministrator"
}

export default UserRole;
